import { FC, useContext, useEffect, useRef, useState } from "react";
import { Button, CustomLink, Input, Layout, MasterCard, MasterTable, Result } from "../../components";
import logo from "../../assets/logo.svg";
import $api from "../../http";
import config from "../../config";
import { Master, Response } from "../../types";
import { useNavigate } from "react-router-dom";
import { Context } from "../..";
import styled from "styled-components";
import { AxiosResponse } from "axios";
import { observer } from "mobx-react";

const Image = styled.img`
  width: 130px;
  height: 130px;
  border-radius: 500px;
  margin-top: 20px;
`;

const FileInput = styled.input`
  display: none;
`;

const Label = styled.label`
  position: relative;
  overflow: hidden;
  height: 130px;
  ::before {
    content: "";
    transition: background 0.3s;
    cursor: pointer;
  }
  :hover::before {
    content: "Изменить";
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    color: white;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.4);
    border-radius: 500px;
  }
`;

const EditMaster: FC<{ title: string }> = observer(({ title }) => {
  const navigate = useNavigate();
  const { store } = useContext(Context);
  useEffect(() => {
    if (!store.isAuth) return navigate("/");
    if (store.user.type !== "admin") return navigate(`/${store.user.type}`);
  }, [navigate, store.isAuth, store.user.type]);

  const [masters, setMasters] = useState<Master[]>();
  const [selectedMaster, setSelectedMaster] = useState<Master>();

  const [name, setName] = useState<string>("");
  const [photo, setPhoto] = useState<string>("");
  const [result, setResult] = useState<Response>({ message: "", status: "success" });
  const [fileName, setFileName] = useState<string>("");
  const [uploadedFileName, setUploadedFileName] = useState<string>("");
  const fileRef: any = useRef();

  useEffect(() => {
    $api.get(`${config.API}/master/all`).then(({ data }) => {
      setMasters(data.data);
    });
  }, []);

  useEffect(() => {
    selectedMaster && setName(selectedMaster.name);
    selectedMaster && setPhoto(selectedMaster.photo);
  }, [selectedMaster]);

  useEffect(() => {
    if (fileRef.current && fileRef.current.files[0]) {
      const formData = new FormData();
      formData.append("file", fileRef.current.files[0]);
      $api.post(`${config.API}/file/upload`, formData).then(({ data }) => setUploadedFileName(data.data.file));
    }
  }, [fileName]);

  useEffect(() => {
    setPhoto(uploadedFileName);
  }, [uploadedFileName]);

  const sendData = () => {
    if (!name || !photo) return setResult({ status: "error", message: "Укажите все данные о мастере" });
    $api.put(`${config.API}/master/edit`, { id: selectedMaster!._id, name, photo }).then(({ data }: AxiosResponse<Response>) => {
      return setResult({ ...data });
    });
  };

  return (
    <Layout title={title}>
      <img src={logo} alt="Chiorio logotype" width={120} height={120} style={{ marginBottom: 50 }} />
      <CustomLink to={"/admin"}>{"<-"} Админ панель</CustomLink>
      <MasterTable>
        {masters &&
          masters.map((e: Master) => (
            <MasterCard key={e.name} name={e.name} photo={`${config.API}/${e.photo}`} stat={e.stat} onClick={() => setSelectedMaster(e)} />
          ))}
      </MasterTable>

      {photo && (
        <>
          <FileInput
            type="file"
            id="uploadPhoto"
            ref={fileRef}
            accept="image/*"
            onChange={({ target }) => setFileName(target.value)}
            value={fileName}
          />
          <Label htmlFor="uploadPhoto">
            <Image src={`${config.API}/${photo}`} alt={"avatar"} style={{ marginTop: 0 }} />
          </Label>
        </>
      )}
      {name && <Input value={name} placeholder="Имя мастера" onChange={({ target }) => setName(target.value)} />}
      {name && photo && <Button onClick={sendData}>Сохранить</Button>}
      <Result {...result} />
    </Layout>
  );
});

export default EditMaster;
